enum RoutineLockEnum {
  SELECT_ORDER = 'select_order',
}

export default RoutineLockEnum;
